export default __webpack_public_path__ + "static/media/tete20.16310306.png";